<template>
  <div class="mr-card">
    <div class="title">
      <slot name="title">
        <strong>{{ title.label }}: {{ title.content }}</strong>
      </slot>
      <slot name="titleRight">
        <router-link v-show="allow" :to="to">
          <div class="flex align-center">
            账单明细
            <van-icon name="arrow" class="fs-16 ml-7" />
          </div>
        </router-link>
      </slot>
    </div>
    <div class="content">
      <slot name="content">
        <div><strong class="fs-14">{{ content.label }}: {{ content.unit }}{{ content.total }}</strong></div>
      </slot>
      <div class="count mt-10">
        <slot name="count">
          <div class="count-item">
            <span>免费量：{{ free | formatAmount }}</span>
          </div>
          <div class="count-item">
            <span>下载量：{{ download | formatAmount }}</span>
          </div>
          <div class="count-item">
            <span>付费量：{{ pay | formatAmount }}</span>
          </div>
          <div v-show="sale" class="count-item">
            <span>销售量：{{ sale | formatAmount }}</span>
          </div>
          <div v-if="saleAmount" class="count-item">
            <span>订购量：{{ saleAmount | formatAmount }}</span>
          </div>
        </slot>
      </div>
    </div>
    <div class="footer-wrapper">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Card',
    props: {
      title: {
        type: Object
      },
      content: {
        type: Object
      },
      disabled: {},
      download: {},
      free: {},
      pay: {},
      sale: {
        default: () => false
      },
      saleAmount: {
      },
      allow: {
        type: Boolean,
        defalut: () => true
      },
      to: {
        type: String,
        default: () => '/'
      }
    }
  }
</script>

<style lang="scss" scoped>
.mr-card{
  font-size: 12px;
  border-radius: 15px;
  box-shadow: 0 0 5px 0 rgb(206, 204, 204);
  .title{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 15px;
    border-bottom: 1px solid #E0E2E7;
    a{
      color: inherit;
    }
  }
  .content{
    padding: 10px 16px;
    .count{
      display: flex;
      flex-wrap: wrap;
      .count-item{
        width: 50%;
        color: #9DA4B3;
        margin-bottom: 6px;
      }
    }
  }
  .footer-wrapper{
    border-top: 1px solid #E0E2E7;
  }
  .footer{
    padding: 15px 68px;
    padding-bottom: 15px;
  }
}
</style>
